export default __webpack_public_path__ + "static/media/icon-vehicles.3a409cbc.svg";